import React, { useState } from "react";
import Checkbox from "../../Components/Checkbox";

const Miscellaneous = () => {
  const [userQuery, setUserQuery] = useState({
    Lien_Position: "First",
    occupancy_status: "",
    Loan_purpose: "",
    amortization_type: "Fixed",
    term: "",
    First_Adjustment_Period: "",
    Property_Value: "",
    ltv: "",
    cltv: "",
    Base_loan_amount: "",
    other_financing: "",
    property_type: "SFH",
    state: "NY",
    waive_escrows: false,
    citizenship: "US citizen",
    employment: false,
    doc_type: "Lite Doc",
    dscr: "",
    dti_ratio: "",
    credit_score: "",
    Mortgage_Type: "",
    bankruptcy_type: "",
    FTHB: false,
    LLC: false,
  });
  return (
    <>
      <div className="text-[#333] w-full bg-white p-12 rounded-xl">
        {/* Heading */}

        <div className="flex items-center">
          <h1 className=" px-4 py-1 text-[#333]   text-lg  font-semibold	">
            Product Features
          </h1>
          <h3 className="  text-[#037dfa]  text-xs font-medium   cursor-pointer  ">
            Learn More
          </h3>
        </div>

        <div className="flex w-full space-x-12 my-3">
          <div className="w-1/2">
            <Checkbox
              label={"Waive Escrows"}
              userQuery={userQuery}
              setUserQuery={setUserQuery}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Miscellaneous;
